// src/serviceWorkerRegistration.js — versione standard di Create React App, con
// l'aggiunta del meccanismo "nuova versione disponibile" passato a index.js: non attiva
// mai una versione nuova in silenzio, aspetta sempre una conferma dell'utente.

const isLocalhost = Boolean(
  window.location.hostname === "localhost" ||
    window.location.hostname === "[::1]" ||
    window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)
);

export function register(config) {
  if (process.env.NODE_ENV === "production" && "serviceWorker" in navigator) {
    const publicUrl = new URL(process.env.PUBLIC_URL, window.location.href);
    if (publicUrl.origin !== window.location.origin) return;

    window.addEventListener("load", () => {
      const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;
      if (isLocalhost) {
        checkValidServiceWorker(swUrl, config);
        navigator.serviceWorker.ready.then(() => {
          console.log("Nexiora è pronta per l'uso offline (ambiente locale).");
        });
      } else {
        registerValidSW(swUrl, config);
      }
    });
  }
}

function registerValidSW(swUrl, config) {
  navigator.serviceWorker
    .register(swUrl)
    .then((registration) => {
      // Versione nuova GIÀ scaricata in una visita precedente e rimasta in attesa (ottobre
      // 2026): prima l'avviso compariva solo nel momento esatto del download; se in quel
      // momento la pagina veniva ricaricata, la versione nuova restava in attesa senza
      // nessun avviso e si continuava a vedere quella vecchia. Ora l'avviso «Aggiorna ora»
      // compare anche all'apertura successiva.
      if (registration.waiting && navigator.serviceWorker.controller) {
        console.log("Nuova versione di Nexiora già scaricata, in attesa di conferma.");
        if (config && config.onUpdate) config.onUpdate(registration);
      }
      registration.onupdatefound = () => {
        const installingWorker = registration.installing;
        if (installingWorker == null) return;
        installingWorker.onstatechange = () => {
          if (installingWorker.state === "installed") {
            if (navigator.serviceWorker.controller) {
              // Nuova versione scaricata e pronta, ma NON attivata da sola — passa il
              // controllo a chi ha chiamato register(), che mostrerà un avviso chiaro
              // invece di sostituire la pagina sotto i piedi di chi la sta usando.
              console.log("Nuova versione di Nexiora disponibile.");
              if (config && config.onUpdate) config.onUpdate(registration);
            } else {
              console.log("Nexiora è pronta per l'uso offline.");
              if (config && config.onSuccess) config.onSuccess(registration);
            }
          }
        };
      };

      // Controllo periodico di aggiornamento — chi tiene Nexiora aperta in una scheda per
      // ore (tipico su desktop, lasciata sullo sfondo) non riceverebbe mai l'avviso di
      // nuova versione finché non ricarica manualmente, perché il browser controlla da
      // solo un nuovo service worker solo alla navigazione. Ogni 5 minuti, e ogni volta che
      // si torna su questa scheda dopo averla lasciata in background, chiediamo noi stessi
      // al browser di ricontrollare.
      setInterval(() => { registration.update(); }, 5 * 60 * 1000);
      document.addEventListener("visibilitychange", () => {
        if (document.visibilityState === "visible") registration.update();
      });
    })
    .catch((error) => {
      console.error("Registrazione service worker fallita:", error);
    });
}

function checkValidServiceWorker(swUrl, config) {
  fetch(swUrl, { headers: { "Service-Worker": "script" } })
    .then((response) => {
      const contentType = response.headers.get("content-type");
      if (response.status === 404 || (contentType != null && contentType.indexOf("javascript") === -1)) {
        navigator.serviceWorker.ready.then((registration) => {
          registration.unregister().then(() => { window.location.reload(); });
        });
      } else {
        registerValidSW(swUrl, config);
      }
    })
    .catch(() => {
      console.log("Nessuna connessione — Nexiora gira in modalità offline.");
    });
}

export function unregister() {
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => { registration.unregister(); })
      .catch((error) => { console.error(error.message); });
  }
}
